export default () => {
  if ( window.self !== window.top ) {
    window.top.location.href=window.location.href;
  }
}